<template>
  <v-card class="ma-0 px-1 invoice-desktop" width="100%" flat>
    <v-app-bar flat class="my-0 mb-2 py-1 px-4" dense height="30">
      <v-toolbar-title>{{ $t(type) }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            width="35"
            v-on="on"
            style="background: transparent"
            @click="configDialog = true"
          >
            <v-icon color="primary" style="font-size: 22px"> mdi-cog-outline </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("setting") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!isMobile && !id"
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="create"
            :loading="isLoading"
          >
            <v-icon color="green" style="font-size: 22px">
              mdi-content-save-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("submit") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!isMobile && id"
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="update"
          >
            <v-icon color="green" style="font-size: 22px">
              mdi-content-save-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("submit") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="showCurrency = !showCurrency"
          >
            <v-icon color="primary" style="font-size: 22px">
              {{ showCurrency ? "mdi-currency-usd" : "mdi-currency-usd-off" }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("showCurrency") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="printType == 'normal' ? (printType = 'fish') : (printType = 'normal')"
          >
            <v-icon color="primary" style="font-size: 22px">
              {{
                printType == "normal" ? "mdi-printer-outline" : "mdi-paper-roll-outline"
              }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{
          printType == "normal" ? $t("normalPrint") : $t("invoiceRollprint")
        }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f2']"
            v-bind="attrs"
            icon
            small
            class="float-left"
            @shortkey="addRow()"
            v-on="on"
            @click="addRow()"
          >
            <v-icon color="teal" style="font-size: 22px"> mdi-plus-box-outline </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("newRow") }} (f2)</span>
      </v-tooltip>
      <v-tooltip v-if="selected.length > 0" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="deletDialog = true"
          >
            <v-icon color="pink" style="font-size: 22px"> mdi-trash-can-outline </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("remove") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="showProductList = !showProductList"
          >
            <v-icon color="blue" style="font-size: 22px">
              {{ showProductList ? "mdi-file-table-box-outline" : "mdi-table-large" }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("productList") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo(type + 'List')"
          >
            <v-icon color="primary" style="font-size: 22px">
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("list") }} {{ $t(type) }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon color="primary" style="font-size: 22px"> mdi-arrow-left </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("back") }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form v-if="render" ref="form" v-model="valid" lazy-validation>
      <v-tabs ref="invoiceFormTabs" v-model="invoiceTab" class="invoice-form-tabs">
        <v-tab>
          {{ $t("public-information") }}
        </v-tab>
        <v-tab>{{ $t("otherInputs") }}</v-tab>
        <v-tab :disabled="!documentPermmission">
          {{ $t("documents") }}
        </v-tab>
        <v-tab v-if="type === 'purchase'" :disabled="investorPermmission">
          {{ $t("investors") }}
        </v-tab>
        <v-tab-item class="invoice-main-tab" style="touch-action: none">
          <v-container class="py-0 px-1 invoice-main-tab__body" fluid>
            <v-row class="mt-1 mb-2 mx-0 px-0 input-minimal">
              <v-col
                v-show="bodyStatus == false || !$vuetify.breakpoint.mobile"
                cols="12"
                class="py-1 px-1"
                sm="2"
                md="2"
              >
                <v-text-field
                  v-model="number"
                  height="20"
                  dense
                  :rules="[(v) => !!v || $t('is-required')]"
                  outlined
                  class="dense mb-0"
                  clearable
                  :label="$t('number')"
                  @blur="getInvoiceNumber"
                />
              </v-col>
              <v-col
                class="px-1 xs py-1"
                cols="12"
                :class="{ 'mb-3': $vuetify.breakpoint.mobile }"
                md="2"
                sm="2"
              >
                <autocomplete
                  ref="refAccount"
                  v-model="account"
                  :title="
                    type === 'purchase' || type === 'returnPurchase'
                      ? $t('detailsInvoice')
                      : $t('customer')
                  "
                  type="person"
                  :new-btn="true"
                  :value="account"
                />
              </v-col>
              <v-col
                v-show="bodyStatus == false || !$vuetify.breakpoint.mobile"
                class="px-1 xs py-1"
                :class="{ 'mb-3': $vuetify.breakpoint.mobile }"
                cols="12"
                md="2"
                sm="2"
              >
                <autocomplete
                  ref="refEntrepot"
                  v-model="entrepot"
                  title="entrepot"
                  type="entrepot"
                  :set-init="id ? false : true"
                  :new-btn="true"
                  :value="entrepot"
                  @input="checkProductsCount"
                />
              </v-col>
              <v-col
                class="py-1 px-1"
                cols="12"
                md="2"
                :class="{ 'mb-3': $vuetify.breakpoint.mobile }"
                sm="2"
              >
                <template>
                  <v-text-field
                    id="from"
                    v-model="date"
                    :label="$t('date')"
                    :rules="[(v) => !!v || $t('is-required')]"
                    clear-icon="flaticon2-close-cross"
                    outlined
                    dense
                    clearable
                  />
                  <date-picker
                    v-model="date"
                    element="from"
                    :locale="$store.state.date_locale"
                    :format="$store.state.date_format"
                    auto-submit
                    :min="$store.state.startDate"
                    :max="$store.state.endDate"
                    :color="
                      this.$vuetify.theme.themes[
                        this.$vuetify.theme.isDark ? 'dark' : 'light'
                      ].primary
                    "
                    @close="setDate"
                  />
                </template>
              </v-col>
              <v-col
                cols="12"
                sm="2"
                md="2"
                :class="{ 'mb-3': $vuetify.breakpoint.mobile }"
                class="py-1 px-1"
              >
                <autocomplete
                  v-model="branch"
                  :title="$t('branch')"
                  type="branch"
                  :set-init="true"
                  :value="branch"
                />
              </v-col>
              <v-col
                v-show="
                  (type == 'presale' || type == 'sell' || type == 'returnSell') &&
                  (bodyStatus == false || !$vuetify.breakpoint.mobile)
                "
                cols="12"
                class="py-1 px-1"
                sm="2"
                md="2"
              >
                <v-text-field
                  v-model="officialNumber"
                  height="20"
                  dense
                  hide-details
                  outlined
                  class="dense mb-0"
                  clearable
                  :label="$t('officialNumber')"
                  @blur="getOfficialInvoiceNumber"
                />
              </v-col>
              <!-- Purchase has no officialNumber: fill the 6th slot with due date (same md=2). -->
              <v-col
                v-if="
                  type !== 'presale' && type !== 'sell' && type !== 'returnSell'
                "
                v-show="bodyStatus == false || !$vuetify.breakpoint.mobile"
                cols="12"
                class="py-1 px-1"
                md="2"
                sm="2"
                :class="{ 'mb-3': $vuetify.breakpoint.mobile }"
              >
                <template>
                  <v-text-field
                    id="dueDateId"
                    v-model="dueDate"
                    :label="$t('dueDate')"
                    clear-icon="flaticon2-close-cross"
                    outlined
                    dense
                    hide-details
                    clearable
                    height="26"
                    class="dense mb-0"
                    @keyup="dueDate = null"
                  />
                  <date-picker
                    v-model="dueDate"
                    element="dueDateId"
                    :locale="$store.state.date_locale"
                    :format="$store.state.date_format"
                    auto-submit
                    :min="date"
                    :max="$store.state.endDate"
                    :color="
                      this.$vuetify.theme.themes[
                        this.$vuetify.theme.isDark ? 'dark' : 'light'
                      ].primary
                    "
                    @close="setDate"
                  />
                </template>
              </v-col>
            </v-row>
            <v-row class="mt-3 mb-2 mx-0 px-0 input-minimal invoice-main-extra-fields">
              <v-col
                v-show="
                  showCurrency && (bodyStatus == false || !$vuetify.breakpoint.mobile)
                "
                cols="12"
                sm="2"
                md="2"
                class="py-1 px-1"
                :class="{ 'mb-3': $vuetify.breakpoint.mobile }"
              >
                <autocomplete
                  ref="refCurrency"
                  v-model="currency"
                  :rules="[(v) => !!v || $t('is-required')]"
                  :title="$t('currency')"
                  type="currency"
                  :init="defaultCurrency"
                  :value="currency"
                  @change="changeCurrency"
                />
              </v-col>
              <v-col
                v-show="
                  showCurrency && (bodyStatus == false || !$vuetify.breakpoint.mobile)
                "
                cols="12"
                sm="2"
                md="2"
                :class="{ 'mb-0': $vuetify.breakpoint.mobile }"
                class="py-1 px-1"
              >
                <money
                  v-model="currency_amount"
                  :label="$t('currency-rate')"
                  :dense="true"
                  :outlined="true"
                  :solo="false"
                  :clearable="true"
                  value-when-is-empty=""
                  :options="options"
                  class="dense mb-0"
                />
              </v-col>
              <!-- Sell/presale: first row already has officialNumber; keep due date here. -->
              <v-col
                v-if="type === 'presale' || type === 'sell' || type === 'returnSell'"
                v-show="bodyStatus == false || !$vuetify.breakpoint.mobile"
                cols="12"
                class="py-1 px-1"
                md="2"
                sm="2"
                :class="{ 'mb-3': $vuetify.breakpoint.mobile }"
              >
                <template>
                  <v-text-field
                    id="dueDateIdSell"
                    v-model="dueDate"
                    :label="$t('dueDate')"
                    clear-icon="flaticon2-close-cross"
                    outlined
                    dense
                    hide-details
                    clearable
                    height="26"
                    class="dense mb-0"
                    @keyup="dueDate = null"
                  />
                  <date-picker
                    v-model="dueDate"
                    element="dueDateIdSell"
                    :locale="$store.state.date_locale"
                    :format="$store.state.date_format"
                    auto-submit
                    :min="date"
                    :max="$store.state.endDate"
                    :color="
                      this.$vuetify.theme.themes[
                        this.$vuetify.theme.isDark ? 'dark' : 'light'
                      ].primary
                    "
                    @close="setDate"
                  />
                </template>
              </v-col>
              <v-col
                v-show="
                  (type === 'sell' || type === 'presale') &&
                  (bodyStatus == false || !$vuetify.breakpoint.mobile)
                "
                cols="12"
                :class="{ 'mb-3': $vuetify.breakpoint.mobile }"
                md="2"
                sm="2"
                class="mb-0 px-1 py-1"
              >
                <v-select
                  v-model="priceType"
                  :label="$t('priceTypeCalculate')"
                  :items="priceTypeItems"
                  height="26"
                  dense
                  hide-details
                  outlined
                  item-value="value"
                  item-text="text"
                  item-disabled="disable"
                />
              </v-col>
              <v-col
                v-if="taxPayerSystem && type === 'sell'"
                cols="12"
                md="2"
                sm="2"
                class="py-1 px-1"
              >
                <v-select
                  v-model="pattern"
                  :label="$t('invoiceType')"
                  :items="invoiceTypeItems"
                  height="26"
                  dense
                  hide-details
                  outlined
                  item-value="value"
                  item-text="text"
                />
              </v-col>
              <v-col
                v-if="taxPayerSystem && type === 'sell'"
                cols="12"
                md="2"
                sm="2"
                class="py-1 px-1"
              >
                <v-select
                  v-model="invoicePattern"
                  :label="$t('invoicePattern')"
                  :items="patternItems"
                  height="26"
                  dense
                  hide-details
                  outlined
                  item-value="value"
                  item-text="text"
                />
              </v-col>
              <v-col
                v-if="taxPayerSystem && type === 'sell'"
                v-show="invoicePattern === '4'"
                cols="12"
                class="py-1 px-1"
                sm="2"
                md="2"
              >
                <v-text-field
                  v-model="contractNumber"
                  height="20"
                  dense
                  hide-details
                  outlined
                  class="dense mb-0"
                  clearable
                  :label="$t('contractNumber')"
                />
              </v-col>
            </v-row>
            <v-row class="mt-2 mx-0 invoice-main-tab__table-row">
              <v-col
                v-if="showProductList"
                v-show="bodyStatus == true || !$vuetify.breakpoint.mobile"
                cols="4"
                class="px-1 py-0"
              >
                <products
                  v-model="items"
                  :data="JSON.stringify({ entrepot: entrepot ? entrepot.id : null })"
                  @append="append"
                />
              </v-col>
              <v-col
                class="px-0 py-0 mb-0 pb-0 border-datatable invoice-main-tab__table-col"
              >
                <v-data-table
                  ref="myTable"
                  v-if="headers"
                  v-model="selected"
                  v-column-resize="invoiceColumnPlugins"
                  v-column-drag="invoiceColumnPlugins"
                  v-column-pin="invoiceColumnPlugins"
                  fixed-header
                  :headers="showHeaders"
                  :items="items"
                  :height="tableHeightInvoice"
                  :options.sync="tableOptions"
                  :server-items-length="totalItems"
                  :loading="loading"
                  multi-sort
                  class="mx-1 main-table invoice-sell-table-scroll"
                  style="border-left: 1px solid #e3e3e3; border-right: 1px solid #e3e3e3"
                  dense
                  :show-select="showSelect"
                  hide-default-footer
                  item-key="id"
                  :mobile-breakpoint="0"
                  @touchstart.native.stop
                  @touchmove.native.stop
                >
                  <template v-slot:item="{ item, index }">
                    <invoice-table-row
                      :key="item.id || item._uid || 'row-' + index"
                      :ref="'refProduct' + index"
                      :item="item"
                      :index="index"
                      :row-number="parseInt(index) + parseInt(from)"
                      :type="type"
                      :id="id"
                      :entrepot="entrepot"
                      :options="tableMoneyOptions"
                      :decimal="decimal"
                      :show-serial-feature="showSerialFeature"
                      :columns="showHeaders"
                      :locked-columns="['actions', 'row', 'product']"
                      :shared-product-active="
                        sharedProductEdit.active && sharedProductEdit.index === index
                      "
                      :shared-product-loading="
                        sharedProductEdit.loading &&
                        sharedProductEdit.loadingIndex === index
                      "
                      @activate-shared-product="activateSharedProductEdit"
                      @open-serial-dialog="openSerialDialog"
                      @open-delete-dialog="openDeleteDialog"
                      @clear-row="clearRow"
                      @change-product="changeProduct"
                      @change-entrepot="changeEntrepotAtRow"
                      @calc-sum="scheduleCalcSum"
                      @zero-count-check="zeroCountCheck"
                      @check-count="checkCount"
                      @open-gold-dialog="openGoldDialog"
                      @check-discount="checkDiscount"
                      @check-discount-percent="checkDiscountPercent"
                    />
                  </template>
                </v-data-table>
                <v-row class="ma-0 px-1 invoice-tab-footer">
                  <v-col cols="12" class="py-0 pr-0 pl-0 invoice-actions-area">
                    <v-container class="pa-0 d-flex align-center invoice-footer-bar">
                      <v-btn
                        color="primary"
                        outlined
                        dense
                        height="28"
                        class="invoice-footer-bar__btn"
                        v-shortkey="['f2']"
                        @shortkey="addRow()"
                        @click="addRow()"
                      >
                        <v-icon small>mdi-plus</v-icon>
                        <span>{{ $t("add-new-row") }}</span>
                      </v-btn>
                      <div class="flex-grow-1">
                        <description
                          ref="refContent"
                          v-model="content"
                          class="ma-0 pa-0 description"
                          type="purchase"
                        />
                      </div>
                      <v-container
                        v-if="hasCustomerClub && !id && !isMobile && !isTablet"
                        class="d-flex align-center justify-space-between gap-2 invoice-footer-bar__chip"
                      >
                        <div class="d-flex align-center gap-1">
                          <v-checkbox
                            color="primary"
                            dense
                            hide-details
                            v-model="credit_status"
                          />
                          <v-card-text class="text-caption pa-0">{{
                            $t("club-credit")
                          }}</v-card-text>
                        </div>
                        <div class="d-flex align-center gap-1">
                          <v-btn icon x-small :loading="isLoading" color="secondary">
                            <v-icon
                              size="14"
                              style="cursor: pointer"
                              @click="fetchUserCredit"
                              color="secondary"
                            >
                              mdi-refresh
                            </v-icon>
                          </v-btn>
                          <v-card-text class="text-caption pa-0">{{
                            $numberFormat(userCredit)
                          }}</v-card-text>
                          <v-card-text class="text-caption pa-0">{{
                            currency.symbol
                          }}</v-card-text>
                        </div>
                      </v-container>
                      <v-container
                        v-if="!isMobile && !isTablet"
                        class="d-flex align-center justify-space-between gap-2 invoice-footer-bar__chip invoice-footer-bar__chip--primary"
                      >
                        <v-card-text class="text-caption pa-0 text-primary">
                          {{ $t("remainAmountCustomer") }}
                        </v-card-text>
                        <div class="d-flex align-center gap-1">
                          <v-card-text class="text-caption pa-0 text-primary">
                            {{
                              personInfo && personInfo.remain
                                ? $numberFormat(
                                    parseFloat(
                                      personInfo.remain.remain != 0
                                        ? personInfo.remain.remain
                                        : "0"
                                    )
                                  )
                                : 0
                            }}
                          </v-card-text>
                          <v-card-text class="text-caption pa-0 text-primary">{{
                            currency.symbol
                          }}</v-card-text>
                        </div>
                      </v-container>
                    </v-container>
                    <!-- <template v-slot:default>
                          <thead>
                            <tr>
                              <th
                                style="border-top : 1px solid #e3e3e3 !important;"
                              >
                                <div class="d-flex justify-start">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        v-shortkey="['f2']"
                                        v-bind="attrs"
                                        icon
                                        small
                                        class="float-left"
                                        @shortkey="addRow()"
                                        v-on="on"
                                        @click="addRow()"
                                      >
                                        <v-icon
                                          color="teal"
                                          style="font-size: 22px"
                                        >
                                          mdi-plus-box-outline
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                    <span>{{ $t('newRow') }} (f2)</span>
                                  </v-tooltip>
                                </div>
                              </th>
                              <th style="border-top : 1px solid #e3e3e3 !important;width: 100px">
                                {{ $t('sumItem') }} : {{ $numberFormat(totalCount) }}
                              </th>
                              <th style="border-top : 1px solid #e3e3e3 !important;width: 300px">
                                {{ $t('sum') }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td rowspan="2">
                                <v-col
                                  class="pb-0 pt-0"
                                  cols="12"
                                >
                                  <description
                                    ref="refContent"
                                    v-model="content"
                                    class="mt-1 mb-3"
                                    type="purchase"
                                  />
                                </v-col>
                              </td>
                              <td>{{ $t('amount') }}</td>
                              <td>{{ $numberFormat(+total - +totalTax + +discount) }}</td>
                            </tr>
                            <tr>
                              <td style="background: antiquewhite;">
                                {{ $t('discount') }}
                              </td>
                              <td
                                style="background: antiquewhite"
                                :class="{'d-flex' : percentDiscountStatus}"
                              >
                                <money
                                  v-model="discount"
                                  :dense="true"
                                  :outlined="true"
                                  :solo="false"
                                  :clearable="true"
                                  value-when-is-empty="0"
                                  :options="options"
                                  class="mb-3 dense"
                                  :append-icon="(!percentDiscountStatus ? 'mdi-percent-outline' : null)"
                                  :disabled="(sum > 0 ? (percentDiscountStatus ? true : false) : true)"
                                  @append="discountChangeStatus"
                                  @input="checkTotalDiscount"
                                />
                                <v-text-field
                                  v-if="percentDiscountStatus"
                                  v-model="discountPercent"
                                  append-icon="mdi-currency-usd"
                                  placeholder="%"
                                  class="ms-1"
                                  height="20"
                                  outlined
                                  dense
                                  type="number"
                                  max="100"
                                  min="0"
                                  @keyup="discountCheck"
                                  @blur="discountCheck"
                                  @click:append="discountChangeStatus"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td
                                class="d-flex"
                                style="height: 48px !important;padding: 0px 10px !important;"
                              >
                                <div class="d-flex my-2">
                                  <v-checkbox
                                    v-model="taxStatus"
                                    class="mt-0 mb-0 mx-1"
                                    :label="$t('tax')"
                                    value="active"
                                    hide-details
                                  />
                                  <v-text-field
                                    v-if="taxStatus"
                                    v-model="taxPercent"
                                    :label="$t('taxPercent')"
                                    append-icon="mdi-percent-outline"
                                    outlined
                                    style="width: 135px;min-width: 135px;display: none"
                                    dense
                                    :disabled="((type == 'sell' || type == 'presale') && $store.state.allConfig && $store.state.allConfig.userInt && $store.state.allConfig.userInt.deactiveChangeSellPrice == 'active' ? true : false)"
                                    hide-details
                                    type="number"
                                    clearable
                                  />
                                  <v-checkbox
                                    v-if="showClearing"
                                    v-model="clearingStatus"
                                    class="mt-0 mb-0 mx-1 ms-9"
                                    :label="$t('clearing')"
                                    value="active"
                                    hide-details
                                  />
                                  <autocomplete
                                    v-if="clearingStatus"
                                    ref="refBank"
                                    v-model="bank"
                                    class="ms-2"
                                    style="min-width: 150px"
                                    :title="$t('bank') + '/' + $t('cash')"
                                    :currency-prop="currency.id"
                                    type="bankCash"
                                  />
                                  <v-btn
                                    v-if="bank && clearingStatus && (type == 'sell' || type == 'presale') && bank.pos"
                                    small
                                    outlined
                                    height="32"
                                    style="margin-right: 3px !important;"
                                    color="teal"
                                    @click="sendPriceToPOS(bank.pos, total)"
                                  >
                                    <v-icon
                                      color="teal"
                                      style="font-size: 22px"
                                    >
                                      mdi-point-of-sale
                                    </v-icon>
                                    {{ $t('sendPriceToPOS') }}
                                  </v-btn>
                                  <v-chip
                                    v-if="bank && clearingStatus && type == 'purchase'"
                                    class="ms-2 "
                                    color="primary"
                                    label
                                    outlined
                                    hide-details
                                  >
                                    {{ $t('remain') }}   {{ $t('bank') + '/' + $t('cash') }} : {{ $numberFormat(parseFloat(bank.remain.remain)) }} {{ (currency ? currency.name : '') }}
                                  </v-chip>
                                  <v-chip
                                    v-if="type !== 'purchase'"
                                    class="mx-0 ms-1 ml-1"
                                    label
                                    color="primary"
                                    style="width: 100%"
                                    outlined
                                  >
                                    {{ $t('remain') }}   {{ $t('customer') }} : {{ $numberFormat(parseFloat((personInfo && personInfo.remain ? personInfo.remain.remain : 0))) }} {{ (currency ? currency.name : '') }}
                                  </v-chip>
                                </div>
                              </td>
                              <td style="background: aliceblue;">
                                {{ $t('tax') }}
                              </td>
                              <td style="background: aliceblue;">
                                {{ $numberFormat(totalTax) }}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <v-col
                                  v-if="payments"
                                  class="py-0"
                                >
                                  <v-chip
                                    v-for="(item,key) in payments"
                                    :key="key"
                                    class="ma-2 my-1 mt-0"
                                    :close="(!item.chip ? false : true)"
                                    color="blue"
                                    outlined
                                    label
                                    @click:close="(item.payments.lock === null ? item.chip = false : item.chip = true)"
                                  >
                                    {{ $t(item.payments.type) }}
                                    - {{ $t('amount') }} : {{ $numberFormat(parseFloat(item.payments.amount)) }}  {{ item.payments.currency.symbol }}
                                    - {{ $t('number') }}  : {{ item.payments.id }}
                                    <v-icon
                                      v-if="!item.chip"
                                      color="green"
                                      class="mx-2"
                                      @click="item.chip = true"
                                    >
                                      mdi-refresh
                                    </v-icon>
                                    <v-icon
                                      v-if="!item.chip && item.payments.lock === null"
                                      color="pink"
                                    >
                                      mdi-trash-can-outline
                                    </v-icon>
                                    <v-icon
                                      v-if="item.payments && item.payments.lock === 'active'"
                                      color="pink"
                                      class="ms-2"
                                    >
                                      mdi-lock-outline
                                    </v-icon>
                                  </v-chip>
                                </v-col>
                                <v-col
                                  v-if="checks"
                                  class="py-0"
                                >
                                  <v-chip
                                    v-for="(item,key) in checks"
                                    :key="key"
                                    class="ma-2 my-1 mt-0"
                                    :close="(!item.chip ? false : true)"
                                    color="deep-orange"
                                    outlined
                                    label
                                    @click:close="(item.checks.lock === null ? item.chip = false : item.chip = true)"
                                  >
                                    {{ $t('check') }} {{ $t(item.checks.type) }}
                                    - {{ $t('amount') }} : {{ $numberFormat(parseFloat(item.checks.amount)) }}  {{ item.checks.currency.symbol }}
                                    - {{ $t('number') }}  : {{ item.checks.number }}
                                    <v-icon
                                      v-if="!item.chip"
                                      color="green"
                                      class="mx-2"
                                      @click="item.chip = true"
                                    >
                                      mdi-refresh
                                    </v-icon>
                                    <v-icon
                                      v-if="!item.chip && !item.checks.lock"
                                      color="pink"
                                    >
                                      mdi-trash-can-outline
                                    </v-icon>
                                    <v-icon
                                      v-if="item.checks && item.checks.lock === 'active'"
                                      color="pink"
                                      class="ms-2"
                                    >
                                      mdi-lock-outline
                                    </v-icon>
                                  </v-chip>
                                </v-col>
                              </td>
                              <td>{{ $t('total') }}</td>
                              <td>
                                {{ $numberFormat(total) }}
                              </td>
                            </tr>
                          </tbody>
                        </template> -->
                    <v-container class="pa-0 d-flex gap-2 mt-2 first-column">
                      <div class="d-flex gap-2 second-column">
                        <div
                          class="invoice-payment-grid invoice-payment-grid--no-restaurant"
                        >
                          <div class="invoice-payment-grid__primary-col">
                            <v-btn
                              v-if="!id"
                              color="primary"
                              class="invoice-payment-grid__btn invoice-submit-btn-fix invoice-payment-grid__btn--compact"
                              :height="resolveSubmitBtnHeight()"
                              :loading="isLoading"
                              @click="create"
                            >
                              <my-icon
                                :name="'bottom-left-cursor-icon'"
                                :width="15"
                                :height="15"
                                :cursor-pointer="true"
                              />
                              <span class="mr-1">{{ $t("submit") }}</span>
                            </v-btn>
                            <v-btn
                              v-if="id"
                              color="primary"
                              class="invoice-payment-grid__btn invoice-payment-grid__btn--compact"
                              :height="resolveSubmitBtnHeight()"
                              :loading="isLoading"
                              @click="update"
                            >
                              {{ $t("submit-edit") }}
                            </v-btn>
                            <v-btn
                              color="success"
                              class="invoice-payment-grid__btn invoice-payment-grid__btn--compact"
                              :height="resolveSubmitBtnHeight()"
                              @click="openOptionsDialog('cash-format')"
                            >
                              <my-icon
                                :name="'cash-icon'"
                                :width="19"
                                :height="19"
                                :cursor-pointer="true"
                              />
                              <span class="mr-1">{{
                                compositeType == "recieve"
                                  ? $t("recieve-cash")
                                  : $t("payCash")
                              }}</span>
                            </v-btn>
                            <v-btn
                              color="primary"
                              outlined
                              class="invoice-payment-grid__btn invoice-payment-grid__btn--compact"
                              :height="resolveSubmitBtnHeight()"
                              @click="sendToPosProcess('remain')"
                              :disabled="compositeType == 'pay'"
                            >
                              <my-icon
                                :name="'card-pos-icon'"
                                :width="15"
                                :height="15"
                                :cursor-pointer="true"
                                :compositeType="compositeType"
                              />
                              <span class="mr-1">
                                {{ $t("send-to-pos") }}
                              </span>
                            </v-btn>
                          </div>
                          <div class="invoice-payment-grid__discount-col">
                            <div class="invoice-payment-grid__discount">
                              <div
                                class="discount discount-fieldset-fix invoice-payment-grid__discount-inner invoice-payment-grid__discount-row"
                              >
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      v-on="on"
                                      v-bind="attrs"
                                      outlined
                                      small
                                      color="secondary"
                                      class="invoice-payment-grid__coupon-btn pa-0"
                                      @click="openDiscountModeDialog"
                                    >
                                      <v-icon size="16">mdi-cog-outline</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>{{ $t("discount-Mode") }}</span>
                                </v-tooltip>
                                <div class="invoice-payment-grid__discount-input">
                                  <v-text-field
                                    v-if="percentDiscountStatus"
                                    v-model="discountPercent"
                                    :placeholder="$t('header-discount-placeholder')"
                                    append-icon="mdi-currency-usd"
                                    :height="resolveSubmitBtnHeight()"
                                    outlined
                                    dense
                                    hide-details
                                    type="number"
                                    max="100"
                                    min="0"
                                    class="percent-input"
                                    @focus="onHeaderDiscountFocus"
                                    @input="onHeaderDiscountPercentInput"
                                    @keyup="onHeaderDiscountPercentInput"
                                    @blur="onHeaderDiscountPercentBlur"
                                    @click:append="discountChangeStatus"
                                  />
                                  <money
                                    v-else
                                    :key="'header-discount-' + headerDiscountInputKey"
                                    v-model="discount"
                                    :placeholder="$t('header-discount-placeholder')"
                                    :dense="true"
                                    :outlined="true"
                                    :solo="false"
                                    :clearable="true"
                                    :hide-details="true"
                                    value-when-is-empty="0"
                                    :options="options"
                                    :height="String(resolveSubmitBtnHeight())"
                                    class="mb-0 dense invoice-payment-grid__discount-money"
                                    :append-icon="
                                      !percentDiscountStatus
                                        ? 'mdi-percent-outline'
                                        : null
                                    "
                                    :disabled="
                                      sum > 0
                                        ? percentDiscountStatus
                                          ? true
                                          : false
                                        : true
                                    "
                                    @append="discountChangeStatus"
                                    @focus="onHeaderDiscountFocus"
                                    @input="onHeaderDiscountInput"
                                    @blur="onHeaderDiscountBlur"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="invoice-payment-grid__action-grid">
                              <v-btn
                                v-if="!id"
                                color="secondary"
                                outlined
                                disabled
                                :loading="isLoading"
                                class="invoice-payment-grid__btn invoice-payment-grid__btn--compact"
                                :height="resolveSubmitBtnHeight()"
                                @click="create"
                              >
                                <my-icon
                                  :name="'print-icon'"
                                  :width="19"
                                  :height="19"
                                  :cursor-pointer="true"
                                />
                                <span class="mr-1">{{ $t("invoicePrint") }}</span>
                              </v-btn>
                              <v-btn
                                v-if="id"
                                color="secondary"
                                outlined
                                disabled
                                :loading="isLoading"
                                class="invoice-payment-grid__btn invoice-payment-grid__btn--compact"
                                :height="resolveSubmitBtnHeight()"
                                @click="update"
                              >
                                <my-icon
                                  :name="'print-icon'"
                                  :width="19"
                                  :height="19"
                                  :cursor-pointer="true"
                                />
                                <span class="mr-1">{{ $t("invoicePrint") }}</span>
                              </v-btn>
                              <v-btn
                                v-if="!id"
                                color="secondary"
                                :loading="isLoading"
                                disabled
                                outlined
                                class="invoice-payment-grid__btn invoice-payment-grid__btn--compact"
                                :height="resolveSubmitBtnHeight()"
                                @click="create"
                              >
                                <span>{{ $t("submit&print") }}</span>
                              </v-btn>
                              <v-btn
                                v-if="id"
                                color="secondary"
                                :loading="isLoading"
                                outlined
                                disabled
                                class="invoice-payment-grid__btn invoice-payment-grid__btn--compact"
                                :height="resolveSubmitBtnHeight()"
                                @click="update"
                              >
                                <span>{{ $t("edit&print") }}</span>
                              </v-btn>
                              <div
                                class="composite-responsive-wrapper invoice-payment-grid__composite-cell invoice-payment-grid__composite-cell--solo"
                              >
                                <composite
                                  class="composite-responsive invoice-payment-grid__composite-compact"
                                  :compact="true"
                                  @update="onTableUpdate"
                                  :totalTax="totalTax"
                                  :discount="discount"
                                  :total="total"
                                  :credit="credit"
                                  :account="account"
                                  :optionDialogType="optionDialogType"
                                  @closeOptionsDialog="optionDialogType = null"
                                  @totalAmount="totalAmount"
                                  @invoiceRemain="invoiceRemain"
                                  :propType="compositeType"
                                  :propDate="date"
                                  :posesList="posesList"
                                  :isInvoiceCreated="isInvoiceCreated"
                                  :editCompositeTableData="editCompositeTableData"
                                  :currency="currency"
                                  :factor="true"
                                  :pos="true"
                                  :returnPosInfo="returnPosInfo"
                                  @sendToPosProcess="sendToPosProcess"
                                  :isPosSuccessfull="isPosSuccessfull"
                                  @successAdded="isPosSuccessfull = false"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="flex-fill invoice-total-panel">
                        <div
                          class="header-total d-flex align-center justify-space-between"
                        >
                          <v-card-text class="pa-0 text-caption" style="color: #0066ff">{{
                            $t("sum-total")
                          }}</v-card-text>
                          <v-card-text class="pa-0 text-caption" style="color: #0066ff">
                            {{ $numberFormat(total) }} {{ currency.symbol }}
                          </v-card-text>
                        </div>
                        <div class="body-total d-flex align-center">
                          <v-container class="pa-2" style="border-left: 1px solid silver">
                            <div class="d-flex justify-space-between align-center">
                              <v-card-text class="pa-0 text-caption">{{
                                $t("total-invoice")
                              }}</v-card-text>
                              <v-card-text class="pa-0 text-caption"
                                >{{ $numberFormat(+total - +totalTax + +discount) }}
                                {{ currency.symbol }}</v-card-text
                              >
                            </div>
                            <div class="d-flex justify-space-between align-center my-1">
                              <span class="d-flex align-center">
                                <v-card-text class="pa-0 text-caption">{{
                                  $t("total-tax")
                                }}</v-card-text>
                                <v-icon
                                  size="14"
                                  class="mr-1"
                                  color="secondary"
                                  style="cursor: pointer"
                                  @click="invoiceTab = 1"
                                  >mdi-cog-outline</v-icon
                                >
                              </span>
                              <v-card-text class="pa-0 text-caption"
                                >{{ $numberFormat(totalTax) }}
                                {{ currency.symbol }}</v-card-text
                              >
                            </div>
                            <div class="d-flex justify-space-between align-center">
                              <v-card-text class="pa-0 text-caption">{{
                                $t("total-discount")
                              }}</v-card-text>
                              <v-card-text class="pa-0 text-caption"
                                >{{ $numberFormat(discount) }}
                                {{ currency.symbol }}</v-card-text
                              >
                            </div>
                          </v-container>
                          <v-container class="pa-2">
                            <div class="d-flex justify-space-between align-center">
                              <v-card-text class="pa-0 text-caption">{{
                                $t("count-of-ware")
                              }}</v-card-text>
                              <v-card-text class="pa-0 text-caption">{{
                                items.length
                              }}</v-card-text>
                            </div>
                            <div
                              class="d-flex justify-space-between align-center my-1"
                              v-if="hasCustomerClub"
                            >
                              <v-card-text class="pa-0 text-caption">{{
                                $t("club-credit")
                              }}</v-card-text>
                              <v-card-text class="pa-0 text-caption">
                                {{
                                  !id
                                    ? $numberFormat(creditAmount)
                                    : $numberFormat(prevCredit)
                                }}
                                {{ currency.symbol }}
                              </v-card-text>
                            </div>
                            <div class="d-flex justify-space-between align-center my-1">
                              <v-card-text class="pa-0 text-caption">{{
                                $t("total-payments")
                              }}</v-card-text>
                              <v-card-text class="pa-0 text-caption"
                                >{{
                                  totalPayment ? totalPayment.toLocaleString("fa-IR") : 0
                                }}
                                {{ currency.symbol }}</v-card-text
                              >
                            </div>
                            <div class="d-flex justify-space-between align-center">
                              <v-card-text class="pa-0 text-caption">{{
                                $t("factor-remain")
                              }}</v-card-text>
                              <v-card-text class="pa-0 text-caption"
                                >{{ $numberFormat(remainInvoice) }}
                                {{ currency.symbol }}</v-card-text
                              >
                            </div>
                          </v-container>
                        </div>
                      </div>
                    </v-container>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <div class="app-form-body invoice-other-inputs">
            <v-container fluid class="app-form-container app-form-container--cards pa-3">
              <v-row class="app-form-card-grid ma-0" dense>
                <v-col
                  cols="12"
                  :md="commissionPermission ? 7 : 12"
                  class="pa-2"
                >
                  <div class="app-form-card">
                    <div class="app-form-card__header">
                      <div class="app-form-card__icon" aria-hidden="true">
                        <v-icon color="primary" size="22">mdi-tune-variant</v-icon>
                      </div>
                      <div class="app-form-card__heading">
                        <div class="app-form-card__title">
                          {{ $t("otherInputs") }}
                        </div>
                        <div class="app-form-card__subtitle">
                          {{ $t("other-inputs-hint") }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="app-form-card__body app-form-card__body--stack app-form-card__body--with-notify"
                    >
                      <v-row
                        v-show="bodyStatus == false || !$vuetify.breakpoint.mobile"
                        class="app-form-fields invoice-tax-switch-row ma-0"
                      >
                        <v-col cols="12" sm="6">
                          <div
                            class="invoice-tax-switch"
                            :class="{
                              'invoice-tax-switch--on': selectedTaxOption === 'active',
                            }"
                            role="switch"
                            :aria-checked="
                              selectedTaxOption === 'active' ? 'true' : 'false'
                            "
                            tabindex="0"
                            @click="
                              selectTaxOption({
                                value:
                                  selectedTaxOption === 'active'
                                    ? 'deactive'
                                    : 'active',
                              })
                            "
                            @keydown.space.prevent="
                              selectTaxOption({
                                value:
                                  selectedTaxOption === 'active'
                                    ? 'deactive'
                                    : 'active',
                              })
                            "
                            @keydown.enter.prevent="
                              selectTaxOption({
                                value:
                                  selectedTaxOption === 'active'
                                    ? 'deactive'
                                    : 'active',
                              })
                            "
                          >
                            <span class="invoice-tax-switch__label">{{
                              $t("tax-calc")
                            }}</span>
                            <v-switch
                              :input-value="selectedTaxOption === 'active'"
                              class="invoice-tax-switch__control"
                              color="primary"
                              inset
                              dense
                              hide-details
                              readonly
                            />
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class="app-form-fields ma-0">
                        <v-col
                          v-show="bodyStatus == false || !$vuetify.breakpoint.mobile"
                          cols="12"
                          sm="6"
                        >
                          <v-select
                            v-model="type"
                            :label="$t('documentType')"
                            :items="typeItems"
                            :disabled="
                              this.$route.name === 'presaleEdit' || itemsProp
                                ? false
                                : true
                            "
                            dense
                            hide-details="auto"
                            outlined
                            item-value="value"
                            item-text="text"
                            item-disabled="disable"
                            @input="checkProductsCount"
                          />
                        </v-col>
                        <v-col cols="12" sm="6">
                          <autocomplete
                            v-model="given"
                            :title="$t('accountGiven')"
                            type="given"
                          />
                        </v-col>
                        <v-col
                          v-show="bodyStatus == false || !$vuetify.breakpoint.mobile"
                          cols="12"
                          sm="6"
                        >
                          <status
                            v-model="status"
                            :hideconfig="true"
                            :type="type"
                            :value="status"
                          />
                        </v-col>
                        <v-col
                          v-show="bodyStatus == false || !$vuetify.breakpoint.mobile"
                          cols="12"
                          sm="6"
                        >
                          <tag v-model="tag" :solo="false" :input="tag" :height="25" />
                        </v-col>
                        <v-col
                          v-if="type === 'returnSell' || type === 'purchase'"
                          cols="12"
                          sm="6"
                        >
                          <aicomplete
                            v-model="refInvoice"
                            :title="
                              type === 'returnSell'
                                ? 'refSellInvoice'
                                : 'refPurchaseInvoice'
                            "
                            type="invoices"
                            :val="refInvoice"
                            :cache-items="true"
                            :data="
                              JSON.stringify({
                                type: [type === 'returnSell' ? 'sell' : 'purchase'],
                                account: account ? account.id : null,
                              })
                            "
                          />
                        </v-col>
                      </v-row>
                      <div class="invoice-other-extras">
                        <div
                          v-if="!isMobile && customFieldsPermission"
                          class="invoice-other-extras__panel invoice-other-extras__panel--custom"
                        >
                          <custom-fields
                            v-model="customFields"
                            :value="customFields"
                            type-prop="invoiceCustomFields"
                          />
                        </div>
                        <div class="invoice-other-extras__panel invoice-other-extras__panel--notify">
                          <notification
                            v-model="notifications"
                            :value="notifications"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>

                <v-col
                  v-if="commissionPermission"
                  cols="12"
                  md="5"
                  class="pa-2"
                >
                  <div class="app-form-card">
                    <div class="app-form-card__header">
                      <div class="app-form-card__icon" aria-hidden="true">
                        <v-icon color="primary" size="22">mdi-percent-outline</v-icon>
                      </div>
                      <div class="app-form-card__heading">
                        <div class="app-form-card__title">
                          {{ $t("commission") }}
                        </div>
                        <div class="app-form-card__subtitle">
                          {{ $t("commission-inputs-hint") }}
                        </div>
                      </div>
                    </div>
                    <div class="app-form-card__body app-form-card__body--stack">
                      <v-row
                        v-show="type == 'sell' || type == 'returnSell'"
                        class="app-form-fields ma-0"
                      >
                        <v-col cols="12">
                          <autocomplete
                            v-model="seller"
                            title="visitor"
                            type="person"
                            :new-btn="true"
                            :data="JSON.stringify({ type: 'visitor' })"
                            :value="seller"
                          />
                        </v-col>
                        <v-col cols="12" sm="6">
                          <money
                            v-model="commissionAmount"
                            :dense="true"
                            :outlined="true"
                            :solo="false"
                            :clearable="true"
                            :label="$t('commissionAmount')"
                            value-when-is-empty=""
                            :options="options"
                            :disabled="total > 0 ? false : true"
                            class="dense mb-0"
                            @input="calcCommissionPercent"
                          />
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="commissionPercent"
                            v-disabled-icon-focus
                            :label="$t('commissionPercent')"
                            dense
                            hide-details="auto"
                            outlined
                            suffix="%"
                            :disabled="total > 0 ? false : true"
                            class="dense mb-0"
                            type="number"
                            @focus="focusEvent"
                            @input="calcCommissionAmount"
                          />
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-tab-item>
        <v-tab-item class="app-form-documents-tab invoice-documents-tab">
          <div class="app-form-body">
            <v-container class="app-form-container app-form-documents pt-3 pb-2">
              <form-attachment-doc
                ref="refFilePicker"
                v-model="attachments"
                type-prop="invoice"
                :val="id && attachments ? attachments : null"
              />
            </v-container>
          </div>
        </v-tab-item>
        <v-tab-item>
          <v-row class="mb-3 mx-0">
            <investors v-model="investors" :value="investors" />
          </v-row>
        </v-tab-item>
      </v-tabs>
      <v-card-actions class="pt-0 px-3 pb-0">
        <v-row class="ma-0">
          <v-col v-if="!id" cols="6" class="px-0">
            <!-- <v-btn
              v-if="bodyStatus == false && $vuetify.breakpoint.mobile"
              color="primary"
              class="mr-0"
              @click="bodyStatus = true"
            >
              {{ $t('continuance') }}
            </v-btn> -->
          </v-col>
          <v-col v-if="id" cols="6" class="px-0">
            <!-- <v-btn
              v-if="bodyStatus == false && $vuetify.breakpoint.mobile"
              color="primary"
              class="mr-0"
              @click="bodyStatus = true"
            >
              {{ $t('continuance') }}
            </v-btn> -->
            <!--<v-btn
              v-if="id && bodyStatus || !$vuetify.breakpoint.mobile"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>-->
          </v-col>
          <v-col cols="6" class="px-2">
            <v-btn
              v-if="isMobile && bodyStatus == true"
              color="grey"
              outlined
              class="float-left"
              @click="bodyStatus = false"
            >
              {{ $t("back") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-dialog
      v-model="goldDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="goldDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <div v-if="itemDialog">
          <v-row class="ma-0">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="itemDialog.count"
                v-disabled-icon-focus
                height="20"
                dense
                outlined
                :label="$t('count') + ' / ' + $t('weight')"
                hide-details
                flat
                class="mb-3 dense"
                :rules="[(v) => !!v || $t('is-required')]"
                :suffix="itemDialog.unit ? itemDialog.unit.fame : ''"
                :placeholder="$t('count')"
                type="number"
                @blur="zeroCountCheck(itemDialog)"
                @input="checkCount(itemDialog)"
                @focus="focusEvent"
              />
            </v-col>
            <v-col cols="12" md="4">
              <money
                v-model="itemDialog.fee"
                :dense="true"
                :outlined="true"
                :rules="[feeValidate]"
                :solo="false"
                :label="$t('feePerUnit')"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                :disabled="
                  (type == 'sell' || type == 'presale') &&
                  $store.state.allConfig &&
                  $store.state.allConfig.userInt &&
                  $store.state.allConfig.userInt.deactiveChangeSellPrice == 'active'
                    ? true
                    : false
                "
                class="mb-3 dense"
                @input="calcSum"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="itemDialog.cutie"
                v-disabled-icon-focus
                height="20"
                dense
                outlined
                :label="$t('cutie')"
                hide-details
                flat
                class="mb-3 dense"
                :rules="[(v) => !!v || $t('is-required')]"
                type="number"
                @input="calcSum"
              />
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="itemDialog.construction_wages_percent"
                v-disabled-icon-focus
                height="20"
                dense
                outlined
                :label="$t('construction_wages_percent')"
                hide-details
                flat
                class="mb-3 dense"
                type="number"
                @input="calConstructionWages"
              />
            </v-col>
            <v-col cols="12" md="4">
              <money
                v-model="itemDialog.construction_wages"
                :dense="true"
                :outlined="true"
                :label="$t('construction_wages')"
                :rules="[feeValidate]"
                :solo="false"
                :clearable="true"
                value-when-is-empty=""
                :disabled="true"
                :options="options"
                class="mb-3 dense"
                @input="calcSum"
              />
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="itemDialog.profit_percent"
                v-disabled-icon-focus
                height="20"
                dense
                outlined
                :label="$t('profit_percent')"
                hide-details
                flat
                class="mb-3 dense"
                type="number"
                @input="calProfit"
              />
            </v-col>
            <v-col cols="12" md="4">
              <money
                ref="refProfit"
                v-model="itemDialog.profit"
                :dense="true"
                :outlined="true"
                :rules="[feeValidate]"
                :solo="false"
                :disabled="true"
                :clearable="true"
                value-when-is-empty=""
                :label="$t('profit_percent')"
                :options="options"
                class="mb-3 dense"
                @input="calcSum"
              />
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="itemDialog.commission_percent"
                v-disabled-icon-focus
                height="20"
                dense
                outlined
                :label="$t('commission_percent')"
                hide-details
                flat
                class="mb-3 dense"
                type="number"
                @input="calCommission"
              />
            </v-col>
            <v-col cols="12" md="4">
              <money
                v-model="itemDialog.commission"
                :dense="true"
                :outlined="true"
                :rules="[feeValidate]"
                :solo="false"
                :disabled="true"
                :label="$t('goldCommission')"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                class="mb-3 dense"
                @input="calcSum"
              />
            </v-col>
            <v-col cols="12" md="4">
              <div class="d-flex">
                <money
                  v-model="itemDialog.discount"
                  :dense="true"
                  :label="$t('discount')"
                  :outlined="true"
                  :solo="false"
                  :clearable="true"
                  value-when-is-empty=""
                  :options="options"
                  class="mb-3 dense"
                  :disabled="
                    (type == 'sell' || type == 'presale') &&
                    $store.state.allConfig &&
                    $store.state.allConfig.userInt &&
                    $store.state.allConfig.userInt.deactiveChangeSellPrice == 'active'
                      ? true
                      : itemDialog.fee * itemDialog.count > 0
                      ? false
                      : true
                  "
                  @input="checkDiscount(itemDialog)"
                />
                <v-text-field
                  v-model="itemDialog.discountPercent"
                  v-disabled-icon-focus
                  height="20"
                  dense
                  flat
                  outlined
                  solo
                  suffix="%"
                  class="mb-2 dense ms-1"
                  style="max-width: 80px"
                  type="number"
                  :disabled="
                    (type == 'sell' || type == 'presale') &&
                    $store.state.allConfig &&
                    $store.state.allConfig.userInt &&
                    $store.state.allConfig.userInt.deactiveChangeSellPrice == 'active'
                      ? true
                      : false
                  "
                  @focus="focusEvent"
                  @input="checkDiscountPercent(itemDialog)"
                />
              </div>
            </v-col>
          </v-row>
          <v-divider />
          <v-row class="ma-0">
            <v-col cols="12" md="4">
              {{ $t("cutiePer750") }} : {{ (itemDialog.cutie / 750).toFixed(2) }}
            </v-col>
            <v-col cols="12" md="4">
              {{ $t("rawAmount") }} :
              {{
                $numberFormat(
                  (
                    itemDialog.count *
                    itemDialog.fee *
                    (itemDialog.cutie / 750).toFixed(2)
                  ).toFixed($store.state.currency.decimal)
                )
              }}
            </v-col>
            <v-col cols="12" md="4">
              {{ $t("sumOtherItems") }} :
              {{
                $numberFormat(
                  +(itemDialog.construction_wages ?? 0) +
                    +(itemDialog.profit ?? 0) +
                    +(itemDialog.commission ?? 0)
                )
              }}
            </v-col>
            <v-col cols="12" md="4">
              {{ $t("tax") }} : ({{ itemDialog.product.tax_percent }} %)
              {{
                $numberFormat(
                  (
                    (+(itemDialog.construction_wages ?? 0) +
                      +(itemDialog.profit ?? 0) +
                      +(itemDialog.commission ?? 0)) *
                    (itemDialog.product.tax_percent / 100)
                  ).toFixed($store.state.currency.decimal)
                )
              }}
            </v-col>
            <v-col cols="12" md="4">
              {{ $t("sum") }} :
              {{
                $numberFormat(
                  (+(itemDialog.construction_wages ?? 0) +
                    +(itemDialog.profit ?? 0) +
                    +(itemDialog.commission ?? 0)) *
                    (itemDialog.product.tax_percent / 100) +
                    +(itemDialog.construction_wages ?? 0) +
                    +(itemDialog.profit ?? 0) +
                    +(itemDialog.commission ?? 0) +
                    itemDialog.count *
                      itemDialog.fee *
                      (itemDialog.cutie / 750).toFixed(2) -
                    +(itemDialog.discount ?? 0)
                )
              }}
            </v-col>
          </v-row>
        </div>
        <v-card-actions>
          <v-spacer />
          <v-btn color="pink darken-1" text @click="goldDialog = false">
            {{ $t("close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="paymentDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="80%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="paymentDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("newPayment") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <payments :account="account" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col class="pb-2 px-2" cols="12">
            <print
              :data-prop="reportData"
              :report-prop="reportName"
              :resource-prop="reportName"
            />
          </v-col>
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPriceChange"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5"> Use Google's location service? </v-card-title>

        <v-card-text>
          Let Google help apps determine location. This means sending anonymous location
          data to Google, even when no apps are running.
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn color="green darken-1" text @click="dialogPriceChange = false">
            {{ $t("yes") }}
          </v-btn>

          <v-btn color="pink darken-1" text @click="dialogPriceChange = false">
            {{ $t("no") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loadingDialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          <p style="color: white" class="text-center">
            {{ !lodingText ? $t("syncData") : $t(lodingText) }} ...
          </p>
          <v-progress-linear v-model="progressPercent" color="amber" height="5" />
          <div align="center">
            <p class="white--text mb-0">{{ progressPercent }} %</p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="configDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      :width="isMobile ? '100%' : '50%'"
    >
      <v-card class="pa-5" height="400">
        <v-container class="pa-0 d-flex justify-space-between mb-8">
          <v-card-text class="pa-0 text-body-1">{{ $t("setting") }}</v-card-text>
          <v-icon size="20" @click="configDialog = false" style="cursor: pointer"
            >mdi-close</v-icon
          >
        </v-container>
        <v-tabs v-model="activeTab" vertical>
          <v-tab class="justify-start">
            <img src="@/assets/cash-register/fast-access.png" />
            <v-card-text class="pa-0 text-body-2 ms-2">{{
              $t("fast-access")
            }}</v-card-text>
          </v-tab>
          <v-tab class="justify-start">
            <img src="@/assets/cash-register/pos.png" />
            <v-card-text class="pa-0 text-body-2 ms-2">{{
              $t("pos-device")
            }}</v-card-text>
          </v-tab>
          <!-- <v-tab class="justify-start">
            <img src="@/assets/cash-register/printer.png" />
            <v-card-text class="pa-0 text-body-2 ms-2">{{ $t('printer') }}</v-card-text>
          </v-tab> -->
          <v-tab class="justify-start" disabled>
            <img src="@/assets/cash-register/scales.png" />
            <v-card-text class="pa-0 text-body-2 ms-2">{{ $t("scale") }}</v-card-text>
          </v-tab>
          <v-tab class="justify-start" disabled>
            <img src="@/assets/cash-register/other-setting.png" />
            <v-card-text class="pa-0 text-body-2 ms-2">{{
              $t("otherSetting")
            }}</v-card-text>
          </v-tab>
          <!--fast access-->
          <v-tab-item>
            <v-card-text class="pa-0 text-body-1 mb-5">{{ $t("dashboard") }}</v-card-text>
            <v-container class="pa-0 d-flex flex-column gap-2">
              <!-- <v-container class="box px-3 py-2">
                <v-container class="pa-0 d-flex justify-space-between">
                  <div class="d-flex align-center gap-3">
                    <img src="@/assets/cash-register/fund.png" />
                    <div>
                      <v-card-text class="pa-0 text-body-2">{{ $t('default-cach') }}</v-card-text>
                      <v-card-text class="pa-0 text-caption mt-1" style="color: #747373;">برای تنظیم کردن میزان استفاده ترازو مقدار آن را صفر میکند</v-card-text>
                    </div>
                  </div>
                  <autocomplete
                    v-if="currency"
                    v-model="defaultCash"
                    :title="$t('cash')"
                    :currency-prop="currency.id"
                    type="bankCash"
                    class="mt-1"
                  />
                </v-container>
              </v-container> -->
              <v-container class="box px-3 py-2">
                <v-container class="pa-0 d-flex justify-space-between align-center">
                  <div class="d-flex align-center gap-3">
                    <img src="@/assets/cash-register/calculator.png" />
                    <div>
                      <v-card-text class="pa-0 text-body-2">{{
                        $t("calculator")
                      }}</v-card-text>
                    </div>
                  </div>
                  <v-btn color="primary" outlined height="32" disabled>
                    {{ $t("unlock") }}
                  </v-btn>
                </v-container>
              </v-container>
              <v-container class="box px-3 py-2">
                <v-container class="pa-0 d-flex justify-space-between align-center">
                  <div class="d-flex align-center gap-3">
                    <img src="@/assets/cash-register/keyboard.png" />
                    <div>
                      <v-card-text class="pa-0 text-body-2">{{
                        $t("keyboard")
                      }}</v-card-text>
                    </div>
                  </div>
                  <v-btn color="primary" outlined height="32" disabled>
                    {{ $t("unlock") }}
                  </v-btn>
                </v-container>
              </v-container>
            </v-container>
            <!-- <v-container class="pa-0 d-flex justify-end mt-5">
              <v-btn
                color="error"
                outlined
                height="32"
              >
              {{ $t('delete-data-base') }}
              </v-btn>
            </v-container> -->
          </v-tab-item>
          <!--pos device-->
          <v-tab-item>
            <v-container class="pa-0 d-flex justify-space-between">
              <v-card-text class="pa-0 text-body-1 mb-5">{{
                $t("pos-device")
              }}</v-card-text>
              <v-btn color="primary" outlined height="32" @click="openPosDialog('add')">
                {{ $t("add-new-device") }}
              </v-btn>
            </v-container>
            <v-data-table
              :headers="posHeaders"
              :items="posItems"
              :items-per-page="-1"
              hide-default-footer
              :height="isMobile || isTablet ? 265 : 252"
              fixed-header
              class="pos-table"
            >
              <template v-slot:item.status="{ item, index }">
                <v-checkbox
                  v-model="item.status"
                  :true-value="'active'"
                  :false-value="null"
                  @change="setActiveStatus(index)"
                />
              </template>
              <template v-slot:item.title="{ item, index }">
                {{ item.title }}
              </template>
              <template v-slot:item.posDevice="{ item }">
                {{ item.posDevice.Name }}
              </template>
              <template v-slot:item.bank="{ item }">
                {{ item.bank.name }}
              </template>
              <template v-slot:item.posPort="{ item }">
                {{ item.posPort ? item.posPort : $t("haveNot") }}
              </template>
              <template v-slot:item.posIp="{ item }">
                {{ item.posIp ? item.posIp : $t("haveNot") }}
              </template>
              <template v-slot:header.edit="{ header }">
                <v-container
                  class="pa-0 d-flex align-center justify-space-between ma-0 gap-2"
                >
                  {{ $t("edit") }}
                  <div style="cursor: pointer" @click="openDeletePermissionDialog('all')">
                    <my-icon
                      :name="'trash-icon'"
                      :width="15"
                      :height="15"
                      :cursor-pointer="true"
                      :fill="'#000'"
                    />
                  </div>
                </v-container>
              </template>
              <template v-slot:item.edit="{ item, index }">
                <v-container class="pa-0 d-flex align-center ma-0 justify-space-between">
                  <div
                    style="cursor: pointer"
                    class="pr-2"
                    @click="openPosDialog('edit', item)"
                  >
                    <my-icon
                      :name="'edit-icon'"
                      :width="15"
                      :height="15"
                      :stroke="'#000'"
                      :cursor-pointer="true"
                    />
                  </div>
                  <div
                    style="cursor: pointer"
                    @click="openDeletePermissionDialog('single', item, index)"
                  >
                    <my-icon
                      :name="'trash-icon'"
                      :width="15"
                      :height="15"
                      :cursor-pointer="true"
                      :fill="'#000'"
                    />
                  </div>
                </v-container>
              </template>
            </v-data-table>
          </v-tab-item>
          <!--printer-->
          <!-- <v-tab-item>
            <v-card-text class="pa-0 text-body-1 mb-5">{{ $t('printer') }}</v-card-text>
            <v-container class="pa-0 d-flex flex-column gap-2">
              <v-container class="box px-3 py-2" style="height: 70px;">
                <v-container class="pa-0 d-flex justify-space-between">
                  <v-card-text class="pa-0 text-body-2">{{ $t('choose-printer') }}</v-card-text>
                  <div>
                    <v-autocomplete
                      v-model="selectedPrinter"
                      :rules="[v => !!v || $t('is-required')]"
                      :label="$t('chose-device')"
                      class="mt-2 printer-device"
                      outlined
                      :items="printerList"
                      item-text="Name"
                      item-value="Key"
                      return-object
                    />
                  </div>
                </v-container>
              </v-container>
            </v-container>
          </v-tab-item> -->
          <v-tab-item></v-tab-item>
          <v-tab-item></v-tab-item>
        </v-tabs>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="addNewPosDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      :width="isMobile ? '100%' : '25%'"
    >
      <v-card class="pa-5">
        <v-form ref="posForm" v-model="valid">
          <v-container class="pa-0 d-flex justify-space-between align-center mb-8">
            <v-card-text class="pa-0 text-body-1">{{
              dialogType == "add" ? $t("new-pos-device") : $t("edit-pos-device")
            }}</v-card-text>
            <v-icon size="20" style="cursor: pointer" @click="addNewPosDialog = false"
              >mdi-close</v-icon
            >
          </v-container>
          <v-card-text class="pa-0 text-caption mb-7"
            >اطلاعات دستگاه پوز خود را وارد کنید</v-card-text
          >
          <v-text-field
            v-model="newPos.title"
            :label="$t('caption')"
            :rules="[(v) => !!v || $t('is-required')]"
            outlined
            dense
            clearable
            class="mt-2 mb-8"
          />
          <v-text-field
            v-model="newPos.posIp"
            :label="$t('PosIp')"
            outlined
            dense
            :rules="[(v) => !!v || $t('is-required')]"
            clearable
          />
          <v-text-field
            v-model="newPos.posPort"
            :label="$t('PosPort')"
            outlined
            dense
            clearable
            class="my-8"
            :rules="[(v) => !!v || $t('is-required')]"
          />
          <autocomplete
            v-model="newPos.bank"
            :rules="[(v) => !!v || $t('is-required')]"
            :title="$t('chose-bank')"
            type="bankCash"
            class="mt-8"
          />
          <v-autocomplete
            v-model="newPos.posDevice"
            :rules="[(v) => !!v || $t('is-required')]"
            :label="$t('chose-device')"
            class="mt-8 pos-device"
            outlined
            :items="posesList"
            item-text="Name"
            item-value="Key"
            return-object
          />
          <v-container class="pa-0 d-flex align-center gap-2 mt-4">
            <v-btn color="primary" height="32" @click="checkValidation">
              {{ dialogType == "add" ? $t("confirm") : $t("edit") }}
            </v-btn>
            <v-btn color="secondary" outlined height="32">
              {{ $t("cancel") }}
            </v-btn>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletePermissionDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      :width="isMobile ? '100%' : '25%'"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between">
          <v-card-text class="pa-0 text-body-2">
            {{
              isAllItemsDelete
                ? $t("are you sure you want to delete all items?")
                : $t("Are you sure you want to delete this item ?")
            }}
          </v-card-text>
          <v-icon @click="deletePermissionDialog = false" style="cursor: pointer"
            >mdi-close</v-icon
          >
        </v-container>
        <v-container class="pa-0 d-flex gap-2 mt-7">
          <v-btn color="error" height="32" @click="removePosRecord">
            {{ $t("yes") }}
          </v-btn>
          <v-btn outlined height="32" @click="deletePermissionDialog = false">
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <!--warning dialog -->
    <v-dialog v-model="inquiryDialog" width="400">
      <v-card class="pa-4 text-center">
        <v-btn icon class="close-hover" absolute left top @click="inquiryDialog = false">
          <v-icon color="grey">mdi-close</v-icon>
        </v-btn>

        <v-icon color="orange darken-1" size="64" class="mb-3">
          mdi-alert-circle-outline
        </v-icon>

        <div class="font-weight-bold mb-2">{{ $t("warning") }}</div>

        <v-card-text class="pt-0 body-1 grey--text text--darken-2">
          {{ inquiryMessage }}
        </v-card-text>

        <v-btn color="primary" block class="mt-2" @click="inquiryDialog = false">
          {{ $t("close") }}
        </v-btn>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
    <div class="text"></div>
    <serial-management-dialog
      v-if="showSerialFeature"
      v-model="serialDialog"
      :product="(serialItem && serialItem.product) || {}"
      :entrepot="(serialItem && (serialItem.article_entrepot || entrepot)) || {}"
      :total-count="serialItem && serialItem.count"
      :serials="serialDialogList"
      :serial-flow="serialFlow"
      :loading="serialsLoading"
      :has-more="serialHasMore"
      :selected-serials="(serialItem && serialItem.serials) || []"
      @confirm="setSerials"
      @search="onSerialSearch"
      @load-more="loadMoreSerials"
    />
    <header-discount-mode-dialog
      v-model="discountModeDialog"
      @submit="onHeaderDiscountModeSubmit"
      @cancel="onHeaderDiscountModeCancel"
    />
    <!--
      bugfix //timing render invoice each row
      Edit-only: one shared productService autocomplete, repositioned over clicked row.
    -->
    <div
      v-if="id && sharedProductEdit.warmed"
      ref="sharedProductAutocompleteHost"
      class="shared-product-autocomplete-host"
      :class="{ 'is-active': sharedProductEdit.active }"
      :style="sharedProductEdit.active ? sharedProductEdit.style : null"
    >
      <autocomplete
        ref="sharedProductAutocomplete"
        :value="sharedProductEdit.item ? sharedProductEdit.item.product : null"
        type="productService"
        :data="JSON.stringify({ entrepot: entrepot ? entrepot.id : null })"
        :new-btn="true"
        :new-style="true"
        :type-prop="type"
        :serial-btn="
          showSerialFeature &&
          sharedProductEdit.item &&
          rowHasSerial(sharedProductEdit.item)
        "
        @clear="onSharedProductClear"
        @input="onSharedProductInput"
        @serial-click="
          sharedProductEdit.item && openSerialDialog(sharedProductEdit.item)
        "
      />
    </div>
  </v-card>
</template>

<script>
export default {
  name: "InvoiceDesktopView",
};
</script>

<style>
.percent-input .v-input__control .v-input__slot {
  padding: 0 !important;
}
.percent-input .v-input__control .v-input__slot .v-input__append-inner .v-input__icon {
  justify-content: flex-end;
  min-width: 15px;
  width: 15px;
}
.percent-input
  .v-input__control
  .v-input__slot
  .v-input__append-inner
  .v-input__icon
  .v-icon {
  font-size: 18px;
}
.percent-input .v-input__control .v-input__slot .v-text-field__slot input {
  min-width: 42px;
  padding: 8px 8px 8px 0;
}
@media (max-width: 580px) {
  .first-column,
  .second-column {
    flex-direction: column;
  }
}
@media (min-width: 581px) {
  .body-total {
    flex-direction: column;
  }
  .second-column {
    flex-direction: column;
  }
}
@media (min-width: 1024px) {
  .body-total {
    flex-direction: row;
  }
  .second-column {
    flex-direction: row;
  }
}
@media (min-width: 100px) {
  .flex-fill-media {
    flex: 1 1 auto !important;
  }
}
.invoice-submit-btn-fix {
  min-width: 0 !important;
  white-space: nowrap;
}
.invoice-main-tab {
  height: calc(100vh - 214px);
  min-height: calc(100vh - 214px);
  max-height: calc(100vh - 214px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
/* Documents was sharing 210px offset and sat a few px taller than main tab. */
.invoice-documents-tab.app-form-documents-tab {
  height: calc(100vh - 214px);
  min-height: calc(100vh - 214px);
  max-height: calc(100vh - 214px);
}
.invoice-main-tab__body {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.invoice-main-tab__body > .input-minimal,
.invoice-main-tab__body > .invoice-header-fields {
  flex: 0 0 auto;
}
.invoice-main-tab__table-row {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-bottom: 0 !important;
}
.invoice-main-tab__table-col {
  display: flex !important;
  flex-direction: column;
  min-height: 0 !important;
  height: 100% !important;
  max-height: 100% !important;
  overflow: hidden;
}
.invoice-main-tab__table-col > .v-data-table {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
}
.invoice-tab-footer {
  position: relative;
  z-index: 3;
  flex: 0 0 auto;
  background: #fff;
  padding-top: 6px !important;
  padding-bottom: -1px !important;
  margin-bottom: 0px !important;
  border-top: 1px solid #e8e8e8;
}
.invoice-main-tab__table-col > .v-data-table .v-data-table__wrapper {
  height: 100% !important;
  max-height: 100% !important;
  overflow-y: auto !important;
}
.invoice-actions-area {
  --payment-grid-row-height: 34px;
  --payment-grid-gap: 4px;
  --payment-stack-height: calc(
    var(--payment-grid-row-height) * 3 + var(--payment-grid-gap) * 2
  );
  --payment-primary-col-width: 140px;
  --payment-grid-width: 400px;
}
@media (min-width: 1138px) {
  .invoice-actions-area {
    --payment-grid-row-height: 36px;
  }
}
@media (max-width: 1138px) {
  .invoice-actions-area {
    --payment-primary-col-width: 118px;
    --payment-grid-width: 360px;
  }
}
.second-column {
  align-items: stretch;
}
.invoice-payment-grid {
  display: grid;
  grid-template-columns: var(--payment-primary-col-width) minmax(0, 1fr);
  gap: var(--payment-grid-gap);
  align-items: start;
  min-width: 0;
  flex: 0 0 auto;
  width: var(--payment-grid-width);
  max-width: var(--payment-grid-width);
  height: var(--payment-stack-height) !important;
  min-height: var(--payment-stack-height) !important;
  max-height: var(--payment-stack-height) !important;
  overflow: hidden;
}
@media (max-width: 1138px) {
  .invoice-payment-grid {
    grid-template-columns: var(--payment-primary-col-width) minmax(0, 1fr);
  }
}
@media (max-width: 580px) {
  .invoice-payment-grid {
    max-width: 100%;
    width: 100%;
    grid-template-columns: 1fr 1fr;
  }
}
.invoice-payment-grid__primary-col {
  display: grid;
  grid-template-rows: repeat(3, var(--payment-grid-row-height));
  gap: var(--payment-grid-gap);
  min-width: 0;
  width: 100%;
  height: var(--payment-stack-height) !important;
}
.invoice-payment-grid__primary-col .invoice-payment-grid__btn,
.invoice-payment-grid__primary-col .v-btn {
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
  height: var(--payment-grid-row-height) !important;
  min-height: var(--payment-grid-row-height) !important;
  max-height: var(--payment-grid-row-height) !important;
  font-size: 12px !important;
  letter-spacing: 0 !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.invoice-payment-grid__primary-col .invoice-payment-grid__btn .v-btn__content {
  font-size: 12px;
  height: 100%;
}
.invoice-payment-grid__discount-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: var(--payment-grid-row-height) var(--payment-grid-row-height) var(
      --payment-grid-row-height
    );
  gap: var(--payment-grid-gap);
  min-width: 0;
  width: 100%;
  height: var(--payment-stack-height) !important;
}
.invoice-payment-grid__discount {
  grid-column: 1 / -1;
  align-self: stretch;
  display: flex;
  align-items: stretch;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  height: var(--payment-grid-row-height) !important;
  max-height: var(--payment-grid-row-height) !important;
}
.invoice-payment-grid__discount-row {
  display: flex;
  align-items: center;
  gap: 1.5px;
  width: 100%;
  min-width: 0;
  height: 100%;
  flex: 1 1 auto;
}
.invoice-payment-grid__discount-row > .v-tooltip {
  display: inline-flex;
  align-items: stretch;
  flex: 0 0 auto;
  height: 100%;
}
.invoice-payment-grid__coupon-btn {
  flex: 0 0 auto;
  width: auto !important;
  min-width: unset !important;
  max-width: none !important;
  height: var(--payment-grid-row-height) !important;
  min-height: var(--payment-grid-row-height) !important;
  max-height: var(--payment-grid-row-height) !important;
  align-self: center;
  aspect-ratio: 1;
  padding: 0 !important;
}
.invoice-payment-grid__coupon-btn .v-btn__content {
  height: 100%;
}
.invoice-payment-grid__discount-input {
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
  width: 100%;
  height: 100% !important;
  max-height: 100% !important;
  display: flex;
  align-items: stretch;
}
.invoice-payment-grid__discount-inner {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 100%;
  display: flex;
}
.invoice-payment-grid__discount-input > .v-container,
.invoice-payment-grid__discount-input > div,
.invoice-payment-grid__discount-input > .v-input {
  flex: 1 1 auto;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 100% !important;
  min-height: 0 !important;
  max-height: 100% !important;
  display: flex;
}
.invoice-payment-grid__discount-input .v-input,
.invoice-payment-grid__discount-input .v-text-field,
.invoice-payment-grid__discount-money,
.invoice-payment-grid__discount-money .v-input,
.invoice-payment-grid__discount-money .v-text-field {
  margin-top: 0 !important;
  padding-top: 0 !important;
  flex: 1 1 auto;
  align-self: stretch;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  height: 100% !important;
  max-height: 100% !important;
}
.invoice-payment-grid__discount-input .v-text-field .v-input__control,
.invoice-payment-grid__discount-input .v-input__control,
.invoice-payment-grid__discount-input .v-input__slot,
.invoice-payment-grid__discount-input
  .v-text-field--outlined
  > .v-input__control
  > .v-input__slot,
.invoice-payment-grid__discount-money .v-input__control,
.invoice-payment-grid__discount-money .v-input__slot {
  min-height: 100% !important;
  height: 100% !important;
  max-height: 100% !important;
  width: 100% !important;
}
.invoice-payment-grid__discount-input
  .v-text-field--outlined.v-input--dense
  .v-input__slot,
.invoice-payment-grid__discount-money
  .v-text-field--outlined.v-input--dense
  .v-input__slot {
  min-height: 100% !important;
  height: 100% !important;
  max-height: 100% !important;
  width: 100% !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.invoice-payment-grid__discount-col .discount .v-input__control .v-input__slot,
.invoice-payment-grid__discount-col .discount .v-input__control .v-input__slot.white {
  width: 100% !important;
}
.invoice-payment-grid__discount-input input {
  max-height: none;
  height: 100%;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  font-size: 12px !important;
}
.invoice-payment-grid__discount-input
  .v-text-field.v-text-field--enclosed
  .v-text-field__details {
  display: none;
  min-height: 0 !important;
  height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}
.invoice-payment-grid__discount-input .v-input__slot {
  margin-bottom: 0;
}
.invoice-payment-grid__discount-input .v-text-field--outlined fieldset {
  top: -4px;
  bottom: 0;
  border-radius: 4px;
}
.invoice-payment-grid__discount-input .v-input__append-inner {
  margin-top: 0 !important;
  align-self: center;
}
.invoice-payment-grid__discount-input .v-icon {
  font-size: 16px !important;
}
.discount-fieldset-fix .v-text-field--outlined fieldset {
  top: -4px !important;
}
.invoice-payment-grid__action-grid {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: var(--payment-grid-row-height) var(--payment-grid-row-height);
  grid-row: 2 / 4;
  gap: var(--payment-grid-gap);
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: calc(var(--payment-grid-row-height) * 2 + var(--payment-grid-gap)) !important;
  max-height: calc(
    var(--payment-grid-row-height) * 2 + var(--payment-grid-gap)
  ) !important;
  min-height: 0;
  box-sizing: border-box;
}
.invoice-payment-grid__action-grid > .v-btn {
  width: 100% !important;
  min-width: 0 !important;
  max-width: none !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
  overflow: hidden;
  height: var(--payment-grid-row-height) !important;
  min-height: var(--payment-grid-row-height) !important;
  max-height: var(--payment-grid-row-height) !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  letter-spacing: 0 !important;
}
.invoice-payment-grid__action-grid > .v-btn .v-btn__content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  font-size: 11px;
}
.invoice-payment-grid__action-grid > .invoice-payment-grid__composite-cell {
  width: 100% !important;
  min-width: 0 !important;
  max-width: none !important;
  height: var(--payment-grid-row-height) !important;
  min-height: var(--payment-grid-row-height) !important;
  max-height: var(--payment-grid-row-height) !important;
  display: flex;
}
.invoice-payment-grid__composite-cell--solo {
  grid-column: 1 / -1;
  grid-row: 2;
  align-self: stretch;
}
.invoice-payment-grid__action-grid .composite-responsive-wrapper {
  width: 100% !important;
  max-width: none !important;
  flex: 1 1 auto;
  height: 100% !important;
  max-height: 100% !important;
  display: flex;
}
.invoice-payment-grid__action-grid .composite-responsive {
  width: 100% !important;
  height: 100% !important;
  display: flex;
}
.invoice-payment-grid__composite-compact .v-container {
  height: 100% !important;
  width: 100% !important;
  display: flex !important;
  flex: 1 1 auto;
}
.invoice-payment-grid__composite-compact .v-btn.flex-fill-media {
  width: 100% !important;
  min-width: 0 !important;
  max-width: none !important;
  height: var(--payment-grid-row-height) !important;
  min-height: var(--payment-grid-row-height) !important;
  max-height: var(--payment-grid-row-height) !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  flex: 1 1 auto;
}
.invoice-payment-grid__composite-compact .v-btn.flex-fill-media .mr-1 {
  font-size: 11px;
}
.invoice-payment-grid__btn {
  flex: 0 0 auto;
}
.invoice-payment-grid__btn--compact {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.invoice-payment-grid__btn--compact .v-btn__content {
  font-size: 12px;
}

::v-deep .v-input--selection-controls__input {
  width: 15px;
}
::v-deep .v-input--selection-controls__ripple {
  display: none;
}
.invoice-footer-bar {
  gap: var(--payment-grid-gap, 4px) !important;
}
.invoice-footer-bar > .flex-grow-1 {
  min-width: 0;
  flex: 1 1 0;
  display: flex;
  align-items: stretch;
}
.invoice-footer-bar > .flex-grow-1 .description {
  width: 100% !important;
  flex: 1 1 auto;
  box-sizing: border-box !important;
}
.wrapper .description {
  border: 1px solid silver;
  border-radius: 4px;
}
.invoice-footer-bar .description {
  height: 28px !important;
  min-height: 28px !important;
  max-height: 28px !important;
  margin: 0 !important;
  padding: 0 !important;
  border: 1px solid silver;
  border-radius: 4px;
  overflow: hidden;
  box-sizing: border-box !important;
}
.invoice-footer-bar .description.v-textarea,
.invoice-footer-bar .description .v-input__control,
.invoice-footer-bar .description .v-input__slot {
  min-height: 28px !important;
  height: 28px !important;
}
.invoice-footer-bar .description .v-input__slot {
  align-items: center !important;
}
.invoice-footer-bar .description .v-text-field__slot {
  display: flex !important;
  align-items: center !important;
  height: 100% !important;
}
.invoice-footer-bar .description textarea {
  height: 18px !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  font-size: 12px;
  line-height: 18px;
  overflow: auto !important;
}
.invoice-footer-bar .description textarea::-webkit-scrollbar {
  display: none;
}
.invoice-footer-bar .description .v-input__append-outer {
  margin-top: 0 !important;
  margin-left: 6px;
  align-self: center !important;
}
.invoice-footer-bar .description .v-input__append-outer .v-icon {
  font-size: 16px !important;
}
.invoice-footer-bar .description .v-label {
  font-size: 12px !important;
  line-height: 18px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  height: auto !important;
  margin: 0 !important;
}
.invoice-footer-bar .description .v-label--active {
  display: none;
}
.invoice-footer-bar .description .v-input__append-inner,
.invoice-footer-bar .description .v-input__prepend-inner {
  margin-top: 0 !important;
  align-self: center !important;
  padding: 0 !important;
}
.invoice-footer-bar .description .v-input__append-inner .v-btn,
.invoice-footer-bar .description .v-input__append-inner .v-icon {
  margin-top: 0 !important;
}
.invoice-footer-bar .description .v-input__append-inner .v-icon {
  font-size: 16px !important;
  height: 16px !important;
  width: 16px !important;
}
.invoice-footer-bar .description .v-input__icon--clear {
  margin-top: 0 !important;
  align-self: center;
}
.invoice-footer-bar .description .v-input__slot {
  align-items: center !important;
}
.wrapper
  ::v-deep
  .v-textarea.v-text-field--solo
  .v-input__control
  .v-input__slot
  .v-text-field__slot
  textarea {
  height: 18px !important;
  overflow: auto !important;
  margin-top: 4px;
  font-size: 12px;
  line-height: 18px;
}
.wrapper
  ::v-deep
  .v-textarea.v-text-field--solo
  .v-input__control
  .v-input__slot
  .v-text-field__slot
  textarea::-webkit-scrollbar {
  display: none;
}
.wrapper ::v-deep .v-textarea.v-text-field--solo .v-input__append-outer {
  margin-top: 2px;
  margin-left: 6px;
}
.wrapper ::v-deep .v-textarea.v-text-field--solo .v-input__append-outer .v-icon {
  font-size: 16px !important;
}
.wrapper ::v-deep .v-textarea.v-text-field--solo .v-label {
  font-size: 12px;
  top: 4px !important;
}
.wrapper ::v-deep .v-textarea.v-text-field--solo .v-input__control,
.wrapper ::v-deep .v-textarea.v-text-field--solo .v-input__slot {
  min-height: 28px !important;
  height: 28px !important;
}
.invoice-footer-bar__btn {
  width: var(--payment-primary-col-width) !important;
  min-width: var(--payment-primary-col-width) !important;
  max-width: var(--payment-primary-col-width) !important;
  flex: 0 0 var(--payment-primary-col-width) !important;
  font-size: 12px !important;
  letter-spacing: 0;
  padding: 0 6px !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
}
.invoice-footer-bar__btn .v-btn__content {
  font-size: 12px;
  width: 100%;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.invoice-footer-bar__chip {
  width: auto !important;
  min-width: 240px;
  min-height: 28px !important;
  height: 28px !important;
  padding: 0 12px !important;
  border: 1px solid silver;
  border-radius: 4px;
  margin: 0 !important;
  align-items: center !important;
}
.invoice-footer-bar__chip--primary {
  border-color: #0066ff;
  min-width: 220px;
}
.invoice-footer-bar__chip .text-caption {
  font-size: 12px !important;
  line-height: 1.2;
  white-space: nowrap;
}
.invoice-footer-bar__chip .v-input--checkbox {
  margin: 0 !important;
  padding: 0 !important;
  flex: 0 0 auto;
  align-self: center;
}
.invoice-footer-bar__chip .v-input--checkbox .v-input__control {
  height: 18px !important;
}
.invoice-footer-bar__chip .v-input--checkbox .v-input__slot {
  margin: 0 !important;
  height: 18px !important;
  align-items: center;
}
.invoice-footer-bar__chip .v-input--selection-controls__input {
  width: 18px !important;
  height: 18px !important;
  margin: 0 !important;
  align-self: center;
}
.invoice-footer-bar__chip .v-input--selection-controls__ripple {
  display: none;
}
.invoice-footer-bar__chip .v-icon {
  font-size: 16px !important;
}
.invoice-footer-bar__chip > .d-flex {
  align-items: center !important;
  height: 100%;
}
.header-total {
  border: 1px solid #0066ff;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 0 8px;
}
.v-card__text {
  width: auto;
}
.body-total {
  border: 1px solid silver;
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.invoice-total-panel {
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--payment-stack-height) !important;
  max-height: var(--payment-stack-height) !important;
  min-height: var(--payment-stack-height) !important;
}
.invoice-total-panel .header-total {
  flex: 0 0 38px;
  min-height: 38px !important;
  max-height: 38px !important;
  padding: 0 10px !important;
}
.invoice-total-panel .header-total .v-card__text {
  font-size: 12px !important;
  line-height: 1.25;
  font-weight: 500;
}
.invoice-total-panel .body-total {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}
.invoice-total-panel .body-total > .container {
  padding: 2px 8px !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.invoice-total-panel .body-total .my-1,
.invoice-total-panel .body-total .mt-1 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.invoice-total-panel .body-total .v-card__text {
  font-size: 11px !important;
  line-height: 1.15;
}
.invoice-total-panel .body-total .v-icon {
  font-size: 14px !important;
  height: 14px !important;
  width: 14px !important;
}
.discount ::v-deep .v-input__control .v-input__slot {
  width: 90px;
}
.discount ::v-deep .v-input__control .v-input__slot.white {
  width: 100%;
}
::v-deep .v-input--selection-controls .v-input__slot {
  margin-bottom: 0;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
}
::v-deep .v-messages {
  display: none;
}
::v-deep .v-input--selection-controls.v-input--checkbox {
  margin: 0 !important;
  padding: 0;
}
.invoice-tax-switch-row {
  flex: 0 0 auto;
}
.invoice-tax-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-height: 40px;
  padding: 4px 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.invoice-tax-switch--on {
  border-color: rgba(25, 118, 210, 0.35);
  background: rgba(25, 118, 210, 0.04);
}
.theme--dark .invoice-tax-switch {
  border-color: rgba(255, 255, 255, 0.12);
}
.invoice-tax-switch:hover {
  background: rgba(0, 0, 0, 0.03);
}
.invoice-tax-switch:focus-visible {
  outline: 2px solid var(--v-primary-base, #1976d2);
  outline-offset: -2px;
}
.invoice-tax-switch__label {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 0.9rem;
  line-height: 1.35;
  text-align: start;
}
.invoice-tax-switch__control {
  flex: 0 0 auto;
  margin: 0 !important;
  padding: 0 !important;
  height: auto !important;
}
.invoice-tax-switch__control.v-input--selection-controls {
  margin-top: 0 !important;
}
.invoice-tax-switch__control .v-input__slot {
  margin-bottom: 0 !important;
}
.box {
  border: 1px solid silver;
  background-color: #f5f2f270;
  border-radius: 4px;
}
::v-deep .v-data-table.pos-table .v-data-table-header {
  background-color: #d9d9d9;
}
::v-deep .v-data-table.pos-table {
  border: 1px solid silver;
}
::v-deep .v-data-table.pos-table .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::v-deep .v-data-table.pos-table .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}
::v-deep .v-data-table.pos-table .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
::v-deep .v-data-table.pos-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 8.3pt;
  border-left: 1px solid silver !important;
  padding: 0 9px;
  color: black;
  height: 40px !important;
}
::v-deep
  .v-data-table.pos-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:first-child {
  border-top-right-radius: 4px;
}
::v-deep
  .v-data-table.pos-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:last-child {
  padding: 0 8px 0 4px;
  width: 30px;
  border-left: none;
  border-top-left-radius: 4px;
}
::v-deep .v-data-table.pos-table > .v-data-table__wrapper > table > tbody {
  position: relative;
}
::v-deep .v-data-table.pos-table > .v-data-table__wrapper > table > tbody > tr > td {
  border-left: 1px solid silver !important;
  padding-right: 10px;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  tbody
  tr:first-child:hover
  td:first-child {
  border-top-left-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:last-child {
  border-top-right-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:last-child {
  border-top: 1px solid silver;
  background-color: #f6f6f6;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:nth-last-child(2) {
  background-color: #f6f6f6;
}
::v-deep
  .v-data-table.pos-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:last-child {
  width: 0;
  border-left: none;
  padding: 0 8px 0 3.6pt;
}
::v-deep .v-text-field--outlined.pos-device .v-label {
  top: 6px !important;
}
.invoice-other-inputs {
  min-height: calc(100vh - 214px);
  max-height: calc(100vh - 214px);
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.invoice-other-inputs > .app-form-container {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.invoice-other-inputs .app-form-card-grid {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
}
.invoice-other-inputs .app-form-card-grid > .col {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
}
.invoice-other-inputs .app-form-card {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
}
.invoice-other-inputs .app-form-card__body--with-notify {
  overflow: hidden;
  min-height: 0;
  flex: 1 1 auto;
}
.invoice-other-inputs .app-form-card__body--with-notify > .app-form-fields {
  flex: 0 0 auto !important;
  min-height: 0;
  overflow: visible;
}
/* Equal-height custom-fields + notifications; each scrolls inside. */
.invoice-other-extras {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-top: 4px;
}
.invoice-other-extras__panel {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  padding-top: 8px;
  box-sizing: border-box;
}
.theme--dark .invoice-other-extras__panel {
  border-top-color: rgba(255, 255, 255, 0.1);
}
.invoice-other-extras__panel--custom > .mx-0,
.invoice-other-extras__panel--custom > .custom-fields,
.invoice-other-extras__panel--custom > div {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  margin: 0 !important;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
}
/* Match notification chrome: hide divider, pin add action, scroll only rows. */
.invoice-other-extras__panel--custom > div > .v-divider {
  display: none !important;
}
.invoice-other-extras__panel--custom > div > .row:first-of-type {
  position: sticky;
  top: 0;
  z-index: 2;
  flex: 0 0 auto;
  height: auto !important;
  min-height: 36px !important;
  margin: 0 0 4px !important;
  padding: 0 0 2px !important;
  display: flex !important;
  justify-content: right !important; /* physical right in RTL/LTR */
  align-items: center !important;
  background: #fff;
}
.theme--dark .invoice-other-extras__panel--custom > div > .row:first-of-type {
  background: var(--v-background-base, #1e1e1e);
}
.invoice-other-extras__panel--custom > div > .row:first-of-type .v-btn {
  min-height: 32px !important;
  height: 32px !important;
  margin: 0 !important;
  padding: 0 12px !important;
  border: 0 !important;
  border-radius: 8px !important;
  background: rgba(25, 118, 210, 0.08) !important;
  box-shadow: none !important;
  letter-spacing: normal;
}
.invoice-other-extras__panel--custom > div > .row:first-of-type .v-btn:hover,
.invoice-other-extras__panel--custom > div > .row:first-of-type .v-btn:focus {
  background: rgba(25, 118, 210, 0.14) !important;
}
.theme--dark .invoice-other-extras__panel--custom > div > .row:first-of-type .v-btn {
  background: rgba(144, 202, 249, 0.12) !important;
}
.theme--dark .invoice-other-extras__panel--custom > div > .row:first-of-type .v-btn:hover,
.theme--dark .invoice-other-extras__panel--custom > div > .row:first-of-type .v-btn:focus {
  background: rgba(144, 202, 249, 0.2) !important;
}
.invoice-other-extras__panel--custom > div > .row:not(:first-of-type) {
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-bottom: 8px !important;
}
.invoice-other-extras__panel--notify .app-form-notify {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  overflow: hidden;
}
.invoice-other-extras__panel--notify .app-form-notify__add {
  flex: 0 0 auto;
}
.invoice-other-extras__panel--notify .app-form-notify__scroll {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  overflow-y: auto;
}
.invoice-other-extras__panel--notify .app-form-notify .v-divider {
  display: none !important;
}
.invoice-form-tabs:not(.v-tabs--vertical) > .v-tabs-bar {
  height: 48px !important;
  flex: 0 0 auto;
  margin-bottom: 6px;
}
.invoice-form-tabs:not(.v-tabs--vertical) .v-tab {
  height: 48px !important;
  min-height: 48px !important;
  white-space: nowrap;
}
.invoice-form-tabs:not(.v-tabs--vertical) .v-tabs-slider-wrapper {
  /* Keep underline under labels, not through text */
  bottom: 0 !important;
}
/* bugfix //timing render invoice each row — shared product autocomplete overlay */
.shared-product-autocomplete-host {
  position: fixed;
  top: -9999px;
  left: -9999px;
  width: 320px;
  z-index: 5;
  opacity: 0;
  pointer-events: none;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.shared-product-autocomplete-host.is-active {
  opacity: 1;
  pointer-events: auto;
  z-index: 40;
}
.shared-product-autocomplete-host > div {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.shared-product-autocomplete-host .v-input,
.shared-product-autocomplete-host .v-text-field,
.shared-product-autocomplete-host .v-select {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  font-size: 12px !important;
  width: 100%;
  height: 32px !important;
}
.shared-product-autocomplete-host .v-input > .v-input__control {
  min-height: 32px !important;
  height: 32px !important;
  width: 100%;
}
.shared-product-autocomplete-host .v-text-field--outlined .v-input__control,
.shared-product-autocomplete-host .v-text-field--outlined .v-input__slot,
.shared-product-autocomplete-host
  .v-text-field--outlined.v-input--dense
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
  height: 32px !important;
}
.shared-product-autocomplete-host .v-input__slot {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  box-shadow: none !important;
  margin: 0 !important;
  padding: 0 4px 0 0 !important;
  background: transparent !important;
}
.shared-product-autocomplete-host .v-text-field__slot {
  display: flex !important;
  align-items: center !important;
  height: 32px !important;
  margin: 0 !important;
}
.shared-product-autocomplete-host .input-new-style .v-input__slot {
  background: transparent !important;
  box-shadow: none !important;
}
.shared-product-autocomplete-host fieldset {
  border: none !important;
  top: 0 !important;
}
.shared-product-autocomplete-host .v-input__slot::before,
.shared-product-autocomplete-host .v-input__slot::after {
  display: none !important;
}
.shared-product-autocomplete-host input,
.shared-product-autocomplete-host .v-select__selection,
.shared-product-autocomplete-host .v-select__selections {
  font-size: 12px !important;
  line-height: 32px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  max-height: 32px;
  height: 32px !important;
  margin: 0 !important;
}
.shared-product-autocomplete-host .v-input__append-inner,
.shared-product-autocomplete-host .v-input__prepend-inner,
.shared-product-autocomplete-host
  .v-text-field--outlined.v-input--dense
  .v-input__append-inner,
.shared-product-autocomplete-host
  .v-text-field--outlined
  .v-input__append-inner {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-end !important;
  align-self: center !important;
  height: 32px !important;
  min-height: 32px !important;
  max-height: 32px !important;
  margin: 0 !important;
  margin-top: 0 !important;
  padding: 0 !important;
  gap: 2px;
  transform: translateY(-2px);
}
.shared-product-autocomplete-host .v-input__append-inner .v-btn,
.shared-product-autocomplete-host .v-input__prepend-inner .v-btn {
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  align-self: center !important;
}
.shared-product-autocomplete-host .v-btn.v-btn--icon {
  width: 28px !important;
  height: 28px !important;
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
}
.shared-product-autocomplete-host .v-btn.v-btn--icon:hover,
.shared-product-autocomplete-host .v-btn.v-btn--icon:focus,
.shared-product-autocomplete-host .v-btn.v-btn--icon::before {
  background: transparent !important;
}
.shared-product-autocomplete-host .v-btn.v-btn--icon .v-icon {
  font-size: 18px !important;
  height: 18px !important;
  width: 18px !important;
  line-height: 18px !important;
  margin: 0 !important;
}
.shared-product-autocomplete-host .v-input__icon {
  height: 32px !important;
  width: 24px !important;
  min-width: 24px !important;
  margin: 0 !important;
  margin-top: 0 !important;
  align-self: center !important;
}
.shared-product-autocomplete-host .v-input__icon .v-icon {
  font-size: 18px !important;
  height: 18px !important;
  width: 18px !important;
  margin: 0 !important;
}
.shared-product-autocomplete-host .v-text-field__details,
.shared-product-autocomplete-host .v-messages {
  display: none !important;
  height: 0 !important;
  min-height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* Validation: soft red background only (no red border) */
.invoice-desktop >>> .error--text .v-input__slot,
.invoice-desktop >>> .v-input.error--text > .v-input__control > .v-input__slot,
.shared-product-autocomplete-host .error--text .v-input__slot,
.shared-product-autocomplete-host .v-input.error--text .v-input__slot {
  background: rgba(244, 67, 54, 0.18) !important;
  box-shadow: none !important;
}
.invoice-desktop >>> .error--text fieldset,
.shared-product-autocomplete-host .error--text fieldset {
  border-color: transparent !important;
}
</style>
